Math.clamp = (num, min, max) => Math.min(max, Math.max(min, num))
